export default (payload) => ({
  type: 'UPDATE_LOAN_STATE',
  payload,
});
